import React from "react";
import { Link } from "react-scroll";

function Navbar() {
  return (
    <>
      {/* Name */}
      <p className="cursor-pointer">Kumar</p>

      {/* Oprions */}
      <div className="space-x-6">
        <Link
          to="home"
          spy={true}
          smooth={true}
          offset={0}
          duration={500}
          className="rounded-md cursor-pointer  transition-all duration-300 hover:text-white
        hover:bg-black p-[5px]"
        >
          Home
        </Link>
        <Link
          to="about"
          spy={true}
          smooth={true}
          offset={0}
          duration={500}
          className="rounded-md cursor-pointer  transition-all duration-300 hover:text-white
        hover:bg-black p-[5px]"
        >
          About
        </Link>
        <Link
          to="skills"
          spy={true}
          smooth={true}
          offset={0}
          duration={500}
          className="rounded-md cursor-pointer transition-all duration-300 hover:text-white
        hover:bg-black p-[5px]"
        >
          Skills
        </Link>
        <Link
          to="portfolio"
          spy={true}
          smooth={true}
          offset={0}
          duration={500}
          className="rounded-md cursor-pointer  transition-all duration-300 hover:text-white
        hover:bg-black p-[5px]"
        >
          Portfolio
        </Link>
        <Link
          to="contact"
          spy={true}
          smooth={true}
          offset={0}
          duration={500}
          className="rounded-md cursor-pointer transition-all duration-300 hover:text-white
        hover:bg-black p-[5px]"
        >
          Contact
        </Link>
      </div>
    </>
  );
}

export default Navbar;
